define('views/feedback/rating',[
  "globals",
  "backbone",
  "./dialog"
], function (globals, Backbone, FeedbackDialogView) {
  "use strict";

  return Backbone.View.extend({
    resetDelay: 7500,

    events: {
      "click [data-rating]": "submit",
      "click .popover button": "createDialogView"
    },

    initialize: function () {
      this.buttons = this.$("*[data-rating]");
      globals.content.on("change:location", this.reset, this);
      this.render();
    },

    render: function () {
      if (!globals.onCoverPage()) {
        this.$el.css("display", "inline");
      }

      this.initializePopovers();
      this.$el.removeAttr("disabled");

      return this;
    },

    initializePopovers: function () {
      var $popover = $("#feedback-popover").clone();

      this.buttons.each(function () {
        $(this).popover({
          html: "true",

          title: function () {
            return $popover.find("h5");
          },

          content: function () {
            return $popover.find("div");
          }
        });
      });

      return this;
    },

    createDialogView: function () {
      this.dialogView = new FeedbackDialogView({
        el: $("#feedback-modal").clone(),
        model: this.model,
      }).once("remove", this.reset, this).$el.modal();

      return this;
    },

    submit: function (e) {
      var $el = $(e.currentTarget);

      e.preventDefault();
      this.buttons.prop("disabled", true);

      this.model = this.collection.create({
        rating: +$el.data("rating")
      }, { wait: true });

      this.timeout =
        window.setTimeout( _.bind(this.reset, this), this.resetDelay);

      return this;
    },

    reset: function () {
      window.clearTimeout(this.timeout);

      this.buttons.filter(".active")
                  .delay(this.resetDelay)
                  .removeClass("active");

      this.buttons.prop("disabled", false).each(function () {
        $(this).popover("destroy");
      });

      return this.render();
    }
  });
});

